<template>
  <b-modal ref="approvalModal" :title="modalTitle" size="lg" hide-footer>
    <b-table
      v-if="filteredApprovers && filteredApprovers.length"
      :items="filteredApprovers"
      :fields="approverFields"
      bordered
      hover
      small
    >
      <template #cell(approverBy)="data">
        {{ data.item.approverByName }}
      </template>
      <template #cell(status)="data">
        <b-badge :variant="approverStatusVariant(data.value)">
          {{ approverStatusName(data.value) }}
        </b-badge>
      </template>
      <template #cell(updatedAt)="data">
        {{
          data.item.status !== APPROVER_STATUS.PENDING
            ? formatDateTime(data.value)
            : '--'
        }}
      </template>
    </b-table>

    <p v-else class="text-muted mb-0">Chưa có quy trình duyệt.</p>
  </b-modal>
</template>

<script>
import ApiService from '@/core/services/api.service';
import moment from 'moment';
import { APPROVER_STATUS, APPROVER_STATUS_BADGE_VARIANT } from '@/utils/enum';
import { APPROVER_STATUS_NAME } from '@/utils/enum-name';
import { handleError } from '@/utils/common';

export default {
  name: 'PurchaseRequestApprovalModal',
  props: {
    requestId: {
      type: [String, Number],
      default: null,
    },
    approvers: {
      type: Array,
      default: () => [],
    },
    modalTitle: {
      type: String,
      default: 'Quy trình duyệt',
    },
  },
  data() {
    return {
      APPROVER_STATUS,
      internalApprovers: [],
      loadedRequestId: null,
      selectedStep: null,
      isLoading: false,
    };
  },
  computed: {
    effectiveApprovers() {
      if (this.internalApprovers && this.internalApprovers.length) {
        return this.internalApprovers;
      }
      return this.approvers || [];
    },
    filteredApprovers() {
      if (!this.selectedStep) return this.effectiveApprovers;
      const stepNum = Number(this.selectedStep);
      return (this.effectiveApprovers || []).filter(
        (a) => Number(a.step) === stepNum,
      );
    },
    approverFields() {
      return [
        {
          key: 'step',
          label: 'Bước',
          thStyle: { width: '8%' },
          class: 'text-center',
        },
        {
          key: 'approverBy',
          label: 'Người duyệt',
          thStyle: { width: '25%' },
        },
        {
          key: 'status',
          label: 'Trạng thái',
          thStyle: { width: '15%' },
          class: 'text-center',
        },
        { key: 'note', label: 'Ghi chú' },
        {
          key: 'updatedAt',
          label: 'Thời gian',
          thStyle: { width: '20%' },
          class: 'text-center',
        },
      ];
    },
  },
  methods: {
    open({ step = null } = {}) {
      this.selectedStep = step;
      this.ensureApproversLoaded().finally(() => {
        this.$refs.approvalModal.show();
      });
    },
    approverStatusVariant(val) {
      return APPROVER_STATUS_BADGE_VARIANT[val] || 'secondary';
    },
    approverStatusName(val) {
      return APPROVER_STATUS_NAME[val] || val;
    },
    formatDateTime(val) {
      return val ? moment(val).format('DD/MM/YYYY HH:mm') : '';
    },
    async ensureApproversLoaded() {
      if (
        this.internalApprovers &&
        this.internalApprovers.length &&
        this.loadedRequestId === this.requestId
      )
        return;
      if (this.approvers && this.approvers.length) return;
      if (!this.requestId) return;

      this.isLoading = true;
      try {
        const { data } = await ApiService.get(
          `v2/purchase-requests/${this.requestId}`,
        );
        if (data.status === 200 && data.data) {
          this.internalApprovers = data.data.approvers || [];
          this.loadedRequestId = this.requestId;
        }
      } catch (err) {
        handleError(err);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

